// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"972":"008c13ba","3342":"cc760994"}[chunkId] + ".chunk.css";
};